const messages = {
  title: "Hinnastot ja tuote-esitteet",
  description:
    "Lataa täältä uusimmat esitteet ja flyerit Bridgestone- ja Firestone-renkaistamme henkilöautoihin, SUV-autoihin ja kevytkuorma-autoihin.",
  brochureCategories: {
    products: "Tuotteet",
    brand_and_solutions: "Brändi ja ratkaisut",
    season_and_promotions: "Kausi ja kampanjat",
    format: "Formaatti",
    cars_and_vans: "Henkilöauto, SUV, kevyt kuorma-auto",
    summer: "Kesä",
    winter: "Talvi",
    promotions: "Kampanjat",
    all_season: "Ympärivuotiset",
    truck_and_buses: "Kuorma-auto ja linja-auto",
    motorcycle: "Moottoripyörä",
    agriculture: "Maatalous",
    construction_machinery: "Rakennuskoneet",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiaalit",
    brochures: "Tuote-esitteet",
    price_list: "Hinnastot",
    materials: "Materiaalit",
    video_in_store: "Video tekstityksillä",
    video_online: "Video ilman tekstityksiä",
    banner_website: "Banneri",
    banner_social_media: "Sosiaalinen media",
    logos: "Logot",
  },
  searchMedia: "Anna hakusana",
  searchResults: "Hakutulokset",
};

export default {
  messages,
};
